import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../pagini/Firebase";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  doc,
  updateDoc,
  Timestamp,
  arrayUnion,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import "../stiluri/IstoricActiuni.css";

const IstoricActiuni = () => {
  const { id } = useParams(); // CNP din URL
  const [actiuni, setActiuni] = useState([]);
  const [tipFiltrat, setTipFiltrat] = useState("");
  const [intervalData, setIntervalData] = useState("toate");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [modalUserDetails, setModalUserDetails] = useState(null);
// eslint-disable-next-line no-unused-vars
const [userDetails, setUserDetails] = useState(null);
  const [editActiune, setEditActiune] = useState(null);
  const [showHistoryIds, setShowHistoryIds] = useState([]);

  const auth = getAuth();
  const user = auth.currentUser;

const UserDetailsModal = ({ userDetails, onClose }) => (
  <div className="modal" onClick={onClose}>
    <div className="modal-content max-w-md mx-auto p-6" onClick={(e) => e.stopPropagation()}>
      <span className="close" onClick={onClose}>&times;</span>
      <h2 className="text-xl font-semibold mb-4">Detalii Utilizator</h2>

      {/* Poza de profil rotundă */}
      <div className="flex justify-center mb-4">
        <img
          src={userDetails?.avatar_url || "/default-avatar.png"}
          alt={`${userDetails?.nume} ${userDetails?.prenume}`}
          className="rounded-full border object-cover"
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",  // rotund complet
          }}
        />
      </div>

      <div className="space-y-2 text-sm md:text-base">
        <p><strong>Nume:</strong> {userDetails?.nume || "Inexistent"}</p>
        <p><strong>Prenume:</strong> {userDetails?.prenume || "Inexistent"}</p>
        <p><strong>Instituție:</strong> {userDetails?.institutie || "Inexistent"}</p>
        <p><strong>Funcție:</strong> {userDetails?.functie || "Inexistent"}</p>
        <p><strong>Nr. de telefon:</strong> {userDetails?.telefon || "Inexistent"}</p>
        <p><strong>E-mail:</strong> {userDetails?.email || "Inexistent"}</p>
      </div>
    </div>
  </div>
);

  const formatDataOra = (dataOra) => {
    if (!dataOra) return "-";
    if (dataOra.toDate) return dataOra.toDate().toLocaleString("ro-RO");
    if (dataOra.seconds) return new Date(dataOra.seconds * 1000).toLocaleString("ro-RO");
    return new Date(dataOra).toLocaleString("ro-RO");
  };

  const fetchUserDetails = async (email) => {
    const colRef = collection(db, "Utilizatori");
    const q = query(colRef, where("email", "==", email));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const userData = snapshot.docs[0].data();
      setUserDetails(userData);
      return userData;
    }
    return null;
  };

  const getDateRange = useCallback(() => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    switch (intervalData) {
      case "astazi":
        return { start: now, end: new Date(now.getTime() + 24 * 60 * 60 * 1000) };
      case "ieri":
        return { start: new Date(now.getTime() - 24 * 60 * 60 * 1000), end: now };
      case "3zile":
        return { start: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000), end: new Date(now.getTime() + 24 * 60 * 60 * 1000) };
      case "7zile":
        return { start: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), end: new Date(now.getTime() + 24 * 60 * 60 * 1000) };
      case "30zile":
        return { start: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000), end: new Date(now.getTime() + 24 * 60 * 60 * 1000) };
      case "custom":
        if (customStart && customEnd) {
          return {
            start: new Date(customStart),
            end: new Date(new Date(customEnd).getTime() + 24 * 60 * 60 * 1000),
          };
        }
        return null;
      default:
        return null;
    }
  }, [intervalData, customStart, customEnd]);

  const fetchActiuni = useCallback(async () => {
    if (!id) return;
    const colRef = collection(db, "ActiuniBeneficiari", id, "actiuni");
    let constraints = [];
    if (tipFiltrat) constraints.push(where("dosar", "==", tipFiltrat));
    const range = getDateRange();
    if (range) {
      constraints.push(where("timestamp", ">=", range.start));
      constraints.push(where("timestamp", "<=", range.end));
    }
    constraints.push(orderBy("timestamp", "desc"));
    const q = constraints.length ? query(colRef, ...constraints) : query(colRef);
    const snapshot = await getDocs(q);
    const actiuniData = snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
    setActiuni(actiuniData);
  }, [id, tipFiltrat, getDateRange]);

  useEffect(() => {
    if (!id) return;
    fetchActiuni();
    if (user?.email) fetchUserDetails(user.email);
  }, [id, tipFiltrat, intervalData, customStart, customEnd, fetchActiuni, user?.email]);

  const handleShowUserDetails = async (email) => {
    const ud = await fetchUserDetails(email);
    setModalUserDetails(ud);
  };

  const handleCloseModal = () => setModalUserDetails(null);

  const poateEditaActiune = (actiune) => {
    try {
      const currentUser = getAuth().currentUser;
      if (!currentUser?.email) return false;
      if (actiune.utilizator_email !== currentUser.email) return false;

      let tsMillis = null;
      if (actiune.timestamp?.toMillis) tsMillis = actiune.timestamp.toMillis();
      else if (actiune.timestamp?.seconds) tsMillis = actiune.timestamp.seconds * 1000;
      else if (actiune.data_ora?.toMillis) tsMillis = actiune.data_ora.toMillis();
      else if (actiune.data_ora?.seconds) tsMillis = actiune.data_ora.seconds * 1000;
      else tsMillis = new Date(actiune.timestamp || actiune.data_ora || Date.now()).getTime();

      const ore = (Date.now() - tsMillis) / (1000 * 60 * 60);
      return ore <= 24;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const openEditModal = (actiune) => {
    setEditActiune({
      id: actiune.id,
      tipActiune: actiune.tipActiune || "",
      descriere: actiune.descriere || "",
      locatie: actiune.locatie || "",
      dosar: actiune.dosar || "",
    });
  };

  const saveEditActiune = async () => {
    if (!editActiune?.id) return;
    try {
      const docRef = doc(db, "ActiuniBeneficiari", id, "actiuni", editActiune.id);

      // găsește actiunea curentă pentru a salva valorile vechi
      const actiuneCurenta = actiuni.find(a => a.id === editActiune.id);

await updateDoc(docRef, {
  tipActiune: editActiune.tipActiune,
  descriere: editActiune.descriere,
  locatie: editActiune.locatie,
  dosar: editActiune.dosar,
  modificat_la: Timestamp.now(),
  istoric: arrayUnion({
    tipActiune: actiuneCurenta.tipActiune || "",
    descriere: actiuneCurenta.descriere || "",
    locatie: actiuneCurenta.locatie || "",
    dosar: actiuneCurenta.dosar || "",
    fisier_url: actiuneCurenta.fisier_url || null,
    data_ora: actiuneCurenta.data_ora || actiuneCurenta.timestamp,
    timestamp: Timestamp.now(),
    modificat_de_email: user?.email || "",
    modificat_de_nume: user?.displayName || actiuneCurenta.utilizator_nume || "",
  }),
});


      setEditActiune(null);
      fetchActiuni();
    } catch (err) {
      console.error(err);
      alert("Eroare la salvarea modificărilor.");
    }
  };

  const toggleHistory = (id) => {
    setShowHistoryIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="detalii-grid">
      <h2 className="text-2xl font-semibold mb-6">📜 Istoric Acțiuni</h2>

      {/* Filtre */}
      <div className="mb-4 flex flex-wrap gap-4 items-center">
        <div>
          <label className="mr-2 font-medium">Filtrează după tip acțiune:</label>
          <select value={tipFiltrat} onChange={(e) => setTipFiltrat(e.target.value)} className="border p-1 rounded">
            <option value="">Toate</option>
            <option value="dosar_social">Social</option>
            <option value="dosar_psihologic">Psihologic</option>
            <option value="dosar_angajari">Angajări</option>
            <option value="dosar_financiar">Financiar</option>
            <option value="dosar_juridic">Juridic</option>
            <option value="dosar_medical">Medical</option>
          </select>
        </div>

        <div>
          <label className="mr-2 font-medium">Filtrează după dată:</label>
          <select value={intervalData} onChange={(e) => setIntervalData(e.target.value)} className="border p-1 rounded">
            <option value="toate">Toate</option>
            <option value="astazi">Astăzi</option>
            <option value="ieri">Ieri</option>
            <option value="3zile">Ultimele 3 zile</option>
            <option value="7zile">Ultimele 7 zile</option>
            <option value="30zile">Ultimele 30 zile</option>
            <option value="custom">Personalizat</option>
          </select>
        </div>

        {intervalData === "custom" && (
          <div className="flex gap-2 items-center">
            <input type="date" value={customStart} onChange={(e) => setCustomStart(e.target.value)} className="border p-1 rounded" />
            <input type="date" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} className="border p-1 rounded" />
          </div>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="border p-2">Data/Ora</th>
              <th className="border p-2">Tip Acțiune</th>
              <th className="border p-2">Descriere</th>
              <th className="border p-2">Locație</th>
              <th className="border p-2">Dosar</th>
              <th className="border p-2">Utilizator</th>
              <th className="border p-2">Instituția</th>
              <th className="border p-2">Funcția</th>
              <th className="border p-2">Fișier</th>
              <th className="border p-2">Modificări</th>
            </tr>
          </thead>
          <tbody>
            {actiuni.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center p-4">Nu există acțiuni înregistrate.</td>
              </tr>
            ) : (
              actiuni.map((actiune) => (
                <React.Fragment key={actiune.id}>
                  <tr className="hover:bg-gray-100">
                    <td className="border p-2">{formatDataOra(actiune.data_ora || actiune.timestamp)}</td>
                    <td className="border p-2">{actiune.tipActiune}</td>
                    <td className="border p-2">{actiune.descriere}</td>
                    <td className="border p-2">{actiune.locatie}</td>
                    <td className="border p-2">{actiune.dosar}</td>
                    <td className="border p-2">
                      <button onClick={() => handleShowUserDetails(actiune.utilizator_email)} className="btn btn-link text-primary p-0">
                        {actiune.utilizator_nume} {actiune.utilizator_prenume}
                      </button>
                    </td>
                    <td className="border p-2">{actiune.utilizator_institutie}</td>
                    <td className="border p-2">{actiune.utilizator_functie}</td>
                    <td className="border p-2 text-center">
                      {actiune.fisier_url ? (
                        <a href={actiune.fisier_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Vezi fișier</a>
                      ) : "–"}
                    </td>
 <td className="border p-2 text-center">
  {poateEditaActiune(actiune) && (
    <button onClick={() => openEditModal(actiune)} className="px-2 py-1 bg-yellow-400 rounded mr-1 text-sm">Editare</button>
  )}
  {actiune.istoric?.length > 0 && (
    <button onClick={() => toggleHistory(actiune.id)} className="px-2 py-1 bg-gray-300 rounded text-sm">Istoric</button>
  )}
</td>

                  </tr>

                  {showHistoryIds.includes(actiune.id) && actiune.istoric?.map((h, index) => (
                    <tr key={index} className="bg-gray-100 text-sm">
                      <td className="border p-2">{formatDataOra(h.data_ora)}</td>
                      <td className="border p-2">{h.tipActiune}</td>
                      <td className="border p-2">{h.descriere}</td>
                      <td className="border p-2">{h.locatie}</td>
                      <td className="border p-2">{h.dosar}</td>
                      <td className="border p-2">–</td>
                      <td className="border p-2">–</td>
                      <td className="border p-2">–</td>
                      <td className="border p-2 text-center">
                        {h.fisier_url ? <a href={h.fisier_url} target="_blank" rel="noopener noreferrer">Vezi fișier</a> : ""}
                      </td>
                      <td className="border p-2 text-center italic text-gray-600">Valori vechi</td>
                    </tr>
                  ))}

                </React.Fragment>
              ))
            )}
          </tbody>
        </table>

        {modalUserDetails && <UserDetailsModal userDetails={modalUserDetails} onClose={handleCloseModal} />}
      </div>

      {/* Modal edit acțiune */}
      {editActiune && (
        <div className="modal" onClick={() => setEditActiune(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => setEditActiune(null)}>&times;</span>
            <h3>Editare Acțiune</h3>

            <label>Tip acțiune:</label>
            <input type="text" value={editActiune.tipActiune} onChange={(e) => setEditActiune({ ...editActiune, tipActiune: e.target.value })} className="w-full border p-2 rounded mb-2" />

            <label>Descriere:</label>
            <textarea value={editActiune.descriere} onChange={(e) => setEditActiune({ ...editActiune, descriere: e.target.value })} className="w-full border p-2 rounded mb-2" rows={4} />

            <label>Locație:</label>
            <input type="text" value={editActiune.locatie} onChange={(e) => setEditActiune({ ...editActiune, locatie: e.target.value })} className="w-full border p-2 rounded mb-2" />

            <label>Dosar:</label>
            <select value={editActiune.dosar} onChange={(e) => setEditActiune({ ...editActiune, dosar: e.target.value })} className="w-full border p-2 rounded mb-4">
              <option value="">(none)</option>
              <option value="dosar_social">Social</option>
              <option value="dosar_psihologic">Psihologic</option>
              <option value="dosar_angajari">Angajări</option>
              <option value="dosar_financiar">Financiar</option>
              <option value="dosar_juridic">Juridic</option>
              <option value="dosar_medical">Medical</option>
            </select>

            <button onClick={saveEditActiune} className="px-4 py-2 bg-green-500 text-white rounded mr-2">Salvează</button>
            <button onClick={() => setEditActiune(null)} className="px-4 py-2 bg-gray-300 rounded">Anulează</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IstoricActiuni;
